import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

export default function AvisoLegal() {
  return (
    <>
      <Helmet>
        <title>Aviso Legal | Inerva Psicología</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Header />

      <main className="min-h-screen bg-cream pt-28 pb-20">
        <div className="container-narrow">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-sm">
            <h1 className="text-3xl md:text-4xl mb-2 text-center">Aviso Legal</h1>
            <p className="text-sm text-[var(--color-inerva-text-light)] text-center mb-10">
              Última actualización: 8 de agosto de 2025
            </p>

            <div className="prose prose-sm max-w-none prose-headings:font-serif prose-headings:text-[var(--color-inerva-forest)] prose-p:text-[var(--color-inerva-text)] prose-li:text-[var(--color-inerva-text)]">
              <p>
                <strong>ELEVATE STUDIO S.L</strong>, responsable del sitio web (en adelante responsable),
                pone a disposición de los usuarios la siguiente información, con la que pretende dar cumplimiento
                a las obligaciones dispuestas en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad
                de la Información y de Comercio Electrónico (LSSICE), BOE Nº166, así como informar a todos los usuarios
                del sitio web de cuáles son las condiciones de uso.
              </p>

              <p>
                Toda persona que acceda a este sitio web, asume el papel de usuario, comprometiéndose al cumplimiento
                riguroso de las disposiciones aquí dispuestas, así como a cualquier otra disposición legal que fuera
                de aplicación. <strong>ELEVATE STUDIO S.L</strong>, se reserva el derecho de modificar cualquier tipo
                de información que pudiera aparecer en el sitio web, sin que exista obligación de preavisar o poner
                en conocimiento de los usuarios dichas obligaciones, entendiéndose como suficiente con la publicación
                en este sitio web.
              </p>

              <h2>Datos identificativos del responsable del sitio web</h2>
              <ul>
                <li>DENOMINACIÓN SOCIAL: ELEVATE STUDIO S.L</li>
                <li>CIF: B-75532226</li>
                <li>DOMICILIO: C/ MARACENA Nº3, 18101-BELICENA (GRANADA)</li>
                <li>TELÉFONO: 684053267</li>
                <li>E-MAIL: info@elevate.com.es</li>
                <li>NOMBRE DEL DOMINIO WEB: www.elevate.com.es</li>
                <li>DATOS REGISTRALES: Inscrita en el Registro Mercantil de Granada, con fecha 10/12/2024, número de inscripción 1, hoja 62151.</li>
              </ul>

              <h2>Derechos de la propiedad intelectual e industrial</h2>
              <p>
                El sitio web, incluyendo a título enunciativo, pero no limitativo su programación, edición, compilación
                y demás elementos necesarios para su funcionamiento, los diseños, logotipos, textos, etc, son propiedad
                del responsable, o si es el caso, dispone de licencia o autorización expresa por parte de los autores.
                Todos los contenidos se encuentran protegidos por la normativa de propiedad intelectual e industrial.
              </p>
              <p>
                La reproducción total o parcial, uso, explotación, distribución y comercialización requiere en todo caso
                de la autorización por parte del responsable. Los diseños, logotipos, texto y/o gráficos ajenos al responsable
                pertenecen a sus respectivos propietarios.
              </p>

              <h2>Exención de responsabilidades</h2>
              <p>
                El responsable se exime de cualquier tipo de responsabilidad derivada de la información publicada
                en su sitio web, siempre que esta información haya sido manipulada o introducida por un tercero ajeno
                al mismo.
              </p>

              <h2>Política de enlaces</h2>
              <p>
                Desde el sitio web, es posible que se redirija a contenidos de terceros. El responsable no puede controlar
                siempre los contenidos introducidos por terceros y no asume responsabilidad sobre ellos. En caso de detectar
                contenido ilegal o inapropiado, se procederá a su retirada inmediata.
              </p>

              <h2>Actualización y modificación de la información</h2>
              <p>
                La información que aparece en este sitio web es vigente en la fecha de su última actualización.
                El responsable se reserva el derecho de actualizar, modificar o eliminar la información, pudiendo
                limitar o no permitir el acceso al sitio sin previo aviso.
              </p>

              <h2>Ley aplicable y jurisdicción</h2>
              <p>
                Para la resolución de todas las controversias o cuestiones relacionadas con el presente sitio web o de las
                actividades en él desarrolladas, será de aplicación la legislación española, a la que se someten expresamente
                las partes, siendo competentes los Juzgados y Tribunales del domicilio del usuario o del lugar del cumplimiento
                de la obligación.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
